import { Injectable } from '@angular/core';
import type { Logger } from 'loglevel';

import { LoglevelLoggerFactoryService } from './loglevel-logger-factory.service';

@Injectable({ providedIn: 'root' })
export class LoggerFactoryService {
  constructor(private readonly factory: LoglevelLoggerFactoryService) {}

  create(context: string): Logger {
    return this.factory.create(context);
  }

  createForClass(clazz: Function): Logger {
    return this.factory.createForClass(clazz);
  }
}
